import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names with Tailwind CSS classes
 * Combines clsx for conditional classes with tailwind-merge for proper Tailwind deduplication
 *
 * @param inputs - Class names, objects, or arrays to merge
 * @returns Merged and deduplicated class string
 *
 * @example
 * ```ts
 * cn('px-2 py-1', 'px-4') // => 'py-1 px-4' (tailwind-merge deduplicates)
 * cn('text-red-500', { 'bg-blue-500': true }) // => 'text-red-500 bg-blue-500'
 * cn('hover:bg-red-500', ['text-sm', 'font-bold']) // => 'hover:bg-red-500 text-sm font-bold'
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
